import { render } from "./image.vue?vue&type=template&id=735fd6e9&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"

import "./image.vue?vue&type=style&index=0&id=735fd6e9&lang=less&scoped=true"
import "./image.vue?vue&type=style&index=1&id=735fd6e9&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735fd6e9"]])

export default __exports__